import { Phone, Mail, MapPin } from "lucide-react";
import { useLanguage } from "@/contexts/LanguageContext";

const WHATSAPP_NUMBER = process.env.REACT_APP_WHATSAPP_NUMBER || "+966540423401";
const BUSINESS_ADDRESS = "7644, Abu Al Saud Al Zaini Al Qastalani Street, Al Hada Dist, Jeddah, KSA";

const SOCIAL_LINKS = [
  { name: "WhatsApp", href: `https://wa.me/${WHATSAPP_NUMBER.replace(/\+/g, "")}`, icon: <svg viewBox="0 0 24 24" className="w-5 h-5 fill-current"><path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413z"/></svg> },
  { name: "Instagram", href: "https://www.instagram.com/getblackride/", icon: <svg viewBox="0 0 24 24" className="w-5 h-5 fill-current"><path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zm0-2.163c-3.259 0-3.667.014-4.947.072-4.358.2-6.78 2.618-6.98 6.98-.059 1.281-.073 1.689-.073 4.948 0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98 1.281.058 1.689.072 4.948.072 3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98-1.281-.059-1.69-.073-4.949-.073zm0 5.838c-3.403 0-6.162 2.759-6.162 6.162s2.759 6.163 6.162 6.163 6.162-2.759 6.162-6.163c0-3.403-2.759-6.162-6.162-6.162zm0 10.162c-2.209 0-4-1.79-4-4 0-2.209 1.791-4 4-4s4 1.791 4 4c0 2.21-1.791 4-4 4zm6.406-11.845c-.796 0-1.441.645-1.441 1.44s.645 1.44 1.441 1.44c.795 0 1.439-.645 1.439-1.44s-.644-1.44-1.439-1.44z"/></svg> },
  { name: "Twitter", href: "#", icon: <svg viewBox="0 0 24 24" className="w-5 h-5 fill-current"><path d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-5.214-6.817L4.99 21.75H1.68l7.73-8.835L1.254 2.25H8.08l4.713 6.231zm-1.161 17.52h1.833L7.084 4.126H5.117z"/></svg> },
  { name: "LinkedIn", href: "https://www.linkedin.com/company/getblackride/", icon: <svg viewBox="0 0 24 24" className="w-5 h-5 fill-current"><path d="M20.447 20.452h-3.554v-5.569c0-1.328-.027-3.037-1.852-3.037-1.853 0-2.136 1.445-2.136 2.939v5.667H9.351V9h3.414v1.561h.046c.477-.9 1.637-1.85 3.37-1.85 3.601 0 4.267 2.37 4.267 5.455v6.286zM5.337 7.433c-1.144 0-2.063-.926-2.063-2.065 0-1.138.92-2.063 2.063-2.063 1.14 0 2.064.925 2.064 2.063 0 1.139-.925 2.065-2.064 2.065zm1.782 13.019H3.555V9h3.564v11.452zM22.225 0H1.771C.792 0 0 .774 0 1.729v20.542C0 23.227.792 24 1.771 24h20.451C23.2 24 24 23.227 24 22.271V1.729C24 .774 23.2 0 22.222 0h.003z"/></svg> },
];

const FOOTER_LABELS = {
  en: {
    services: "Services",
    company: "Company",
    explore: "Explore",
    airportTransfers: "Airport Transfers",
    hourlyChauffeur: "Hourly Chauffeur",
    corporateTravel: "Corporate Travel",
    umrahZiyarat: "Umrah & Ziyarat",
    ourFleetLink: "Our Fleet",
    testimonials: "Testimonials",
    blog: "Blog",
    footerDesc: "Premium chauffeur service in Saudi Arabia for airport transfers, executive rides, luxury travel, and private intercity journeys.",
    allRightsReserved: "All rights reserved.",
  },
  ar: {
    services: "الخدمات",
    company: "الشركة",
    explore: "استكشف",
    airportTransfers: "النقل من وإلى المطار",
    hourlyChauffeur: "سائق بالساعة",
    corporateTravel: "سفر الشركات",
    umrahZiyarat: "العمرة والزيارات",
    ourFleetLink: "أسطولنا",
    testimonials: "آراء العملاء",
    blog: "المدونة",
    footerDesc: "خدمة سائق خاص فاخرة في السعودية لانتقالات المطار، والرحلات التنفيذية، والسفر الفاخر، والتنقلات الخاصة بين المدن.",
    allRightsReserved: "جميع الحقوق محفوظة.",
  },
  uz: {
    services: "Xizmatlar",
    company: "Kompaniya",
    explore: "Kashf eting",
    airportTransfers: "Aeroport transferlari",
    hourlyChauffeur: "Soatbay haydovchi",
    corporateTravel: "Korporativ safar",
    umrahZiyarat: "Umra va ziyorat",
    ourFleetLink: "Avtopark",
    testimonials: "Mijozlar fikri",
    blog: "Blog",
    footerDesc: "Saudiya Arabistonida aeroport transferlari, premium shaharlararo safarlar va xususiy yo‘lovchi xizmatlari uchun hashamatli chauffeur xizmati.",
    allRightsReserved: "Barcha huquqlar himoyalangan.",
  },
  ru: {
    services: "Услуги",
    company: "Компания",
    explore: "Направления",
    airportTransfers: "Трансферы из аэропорта",
    hourlyChauffeur: "Шофёр по часам",
    corporateTravel: "Корпоративные поездки",
    umrahZiyarat: "Умра и зиярат",
    ourFleetLink: "Наш автопарк",
    testimonials: "Отзывы",
    blog: "Блог",
    footerDesc: "Премиальный chauffeur-сервис в Саудовской Аравии для аэропортовых трансферов, деловых поездок и частных междугородних маршрутов.",
    allRightsReserved: "Все права защищены.",
  },
};

export default function Footer({ forceDark = false }) {
  const { lang } = useLanguage();
  const labels = FOOTER_LABELS[lang] || FOOTER_LABELS.en;

  const footerLinks = {
    [labels.services]: [
      { label: labels.airportTransfers, href: "#services" },
      { label: labels.hourlyChauffeur, href: "#services" },
      { label: labels.corporateTravel, href: "#corporate" },
      { label: labels.umrahZiyarat, href: "#services" },
    ],
    [labels.company]: [
      { label: labels.ourFleetLink, href: "#fleet" },
      { label: labels.testimonials, href: "#testimonials" },
      { label: labels.blog, href: "/blog" },
      { label: "BlackRide Experience", href: "/experience" },
      { label: "Privacy Policy", href: "/privacy-policy" },
      { label: "Terms & Conditions", href: "/terms-and-conditions" },
    ],
    [labels.explore]: [
      { label: "Chauffeur Service Saudi Arabia", href: "/chauffeur-service-saudi-arabia" },
      { label: "Hajj Transport Saudi Arabia", href: "/hajj-transport-saudi-arabia" },
      { label: "Umrah Transport Saudi Arabia", href: "/umrah-transport-saudi-arabia" },
      { label: "Airport Transfer Saudi Arabia", href: "/airport-transfer-saudi-arabia" },
      { label: "Chauffeur Service Jeddah", href: "/chauffeur-service-jeddah" },
      { label: "Chauffeur Service Riyadh", href: "/chauffeur-service-riyadh" },
      { label: "Chauffeur Service Dammam", href: "/chauffeur-service-dammam" },
      { label: "Airport Transfer Jeddah", href: "/airport-transfer-jeddah" },
      { label: "Jeddah Airport to Makkah Transfer", href: "/jeddah-airport-to-makkah-transfer" },
      { label: "Makkah to Madinah Transfer", href: "/makkah-to-madinah-transfer" },
      { label: "UAE to Saudi Hajj Transport", href: "/uae-to-saudi-hajj-transport" },
      { label: "Qatar to Saudi Hajj Transport", href: "/qatar-to-saudi-hajj-transport" },
      { label: "Umrah Chauffeur Service", href: "/umrah-chauffeur-service" },
      { label: "Corporate Chauffeur Service Saudi Arabia", href: "/corporate-chauffeur-service-saudi-arabia" },
      { label: "Premium Family Transport Saudi Arabia", href: "/premium-family-transport-saudi-arabia" },
      { label: "BlackRide Experience", href: "/experience" },
    ],
  };

  const scrollTo = (href) => {
    if (href === "#") return;
    const el = document.querySelector(href);
    if (el) el.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <footer id="footer" data-testid="footer" className="relative bg-[#0a0a0a] border-t border-white/5 footer-shell">
      <div className="max-w-7xl mx-auto px-6 md:px-12 py-16 md:py-20">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-5 gap-12 mb-16">
          <div className="lg:col-span-2">
            <div className="mb-6">
              <img
                src="/logo-white.png"
                alt="BlackRide Logo"
                className="h-10 md:h-12 w-auto object-contain footer-logo-mark"
              />
            </div>
            <p className="text-sm text-gray-500 leading-relaxed max-w-sm">{labels.footerDesc}</p>
            <div className="mt-4 flex flex-wrap gap-2 text-[11px] uppercase tracking-[0.18em] text-[#C7A239]">
              <span className="rounded-full border border-[#C7A239]/30 px-3 py-1">TGA Approved</span>
              <span className="rounded-full border border-[#C7A239]/30 px-3 py-1">24/7 Service</span>
              <span className="rounded-full border border-[#C7A239]/30 px-3 py-1">Meet &amp; Greet Included</span>
              <span className="rounded-full border border-[#C7A239]/30 px-3 py-1">Owned Fleet</span>
            </div>
            <div className="mt-6 space-y-3">
              <a href={`https://wa.me/${WHATSAPP_NUMBER.replace(/\+/g, "")}`} className="flex items-center gap-3 text-sm text-gray-400 hover:text-white transition-colors" data-testid="footer-phone">
                <Phone className="w-4 h-4 text-[#C7A239]" />{WHATSAPP_NUMBER}
              </a>
              <a href="mailto:hello@getblackride.com" className="flex items-center gap-3 text-sm text-gray-400 hover:text-white transition-colors" data-testid="footer-email">
                <Mail className="w-4 h-4 text-[#C7A239]" />hello@getblackride.com
              </a>
              <div className="flex items-center gap-3 text-sm text-gray-400">
                <MapPin className="w-4 h-4 text-[#C7A239]" />{BUSINESS_ADDRESS}
              </div>
            </div>
          </div>
          {Object.entries(footerLinks).map(([title, links]) => (
            <div key={title}>
              <h4 className="text-sm font-medium text-white mb-4">{title}</h4>
              <ul className="space-y-3">
                {links.map((link) => (
                  <li key={link.label}>
                    {link.href.startsWith("/") ? (
                      <a
                        href={link.href}
                        className="text-sm text-gray-500 hover:text-white transition-colors"
                        data-testid={`footer-link-${link.label.toLowerCase().replace(/\s/g, "-")}`}
                      >
                        {link.label}
                      </a>
                    ) : (
                      <button
                        onClick={() => scrollTo(link.href)}
                        className="text-sm text-gray-500 hover:text-white transition-colors text-left"
                        data-testid={`footer-link-${link.label.toLowerCase().replace(/\s/g, "-")}`}
                      >
                        {link.label}
                      </button>
                    )}
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>
        <div className="border-t border-white/5 pt-8 flex flex-col md:flex-row items-center justify-between gap-6">
          <div className="flex items-center gap-4 text-xs text-gray-500">
            <a href="/privacy-policy" className="hover:text-white transition-colors">Privacy Policy</a>
            <span className="text-gray-700">•</span>
            <a href="/terms-and-conditions" className="hover:text-white transition-colors">Terms & Conditions</a>
          </div>
          <p className="text-xs text-gray-600">&copy; {new Date().getFullYear()} BlackRide. {labels.allRightsReserved}</p>
          <div className="flex items-center gap-4">
            {SOCIAL_LINKS.map((social) => (
              <a key={social.name} href={social.href} target="_blank" rel="noopener noreferrer"
                className="text-gray-600 hover:text-[#C7A239] transition-colors" aria-label={social.name}
                data-testid={`footer-social-${social.name.toLowerCase()}`}>{social.icon}</a>
            ))}
          </div>
        </div>
      </div>
    </footer>
  );
}
